import { render, staticRenderFns } from "./DatabaseTemplate.vue?vue&type=template&id=4ed4b61f&scoped=true"
import script from "./DatabaseTemplate.vue?vue&type=script&lang=js"
export * from "./DatabaseTemplate.vue?vue&type=script&lang=js"
import style0 from "./DatabaseTemplate.vue?vue&type=style&index=0&id=4ed4b61f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed4b61f",
  null
  
)

export default component.exports